import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0d11a340"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "outer-container" }
const _hoisted_2 = { class: "progress-container" }
const _hoisted_3 = { class: "progress-wrapper" }

import { computed, onMounted, onUnmounted } from "vue";
import { useUserStore } from "@/store/userStore";
import { useCourseStore } from "@/store/courseStore";
import axios from "axios";

const maxProgress = 5;


export default /*#__PURE__*/_defineComponent({
  __name: 'DailyMilestoneBar',
  setup(__props) {

const userStore = useUserStore();
const courseStore = useCourseStore();
const isSchoolUser = computed(() => courseStore.isSchoolUser);
const progressPercentage = computed(() => {
  return maxProgress > 0 ? (userStore.currentProgress / maxProgress) * 100 : 0;
});

async function initializeDailyBaseline() {
  const response = await axios.get("/api/course/list");

  const totalCompletedWords = response.data.reduce(
    (sum, course) => sum + (course.userEnrollment?.completedWords || 0),
    0,
  );
  const totalCompletedSentences = response.data.reduce(
    (sum, course) => sum + (course.userEnrollment?.completedSentences || 0),
    0,
  );
  const startOfDayBaseline = totalCompletedWords + totalCompletedSentences;

  userStore.setDailyBaseline(startOfDayBaseline);
}

async function updateDailyProgress() {
  const response = await axios.get("/api/course/list");

  const totalCompletedWords = response.data.reduce(
    (sum, course) => sum + (course.userEnrollment?.completedWords || 0),
    0,
  );
  const totalCompletedSentences = response.data.reduce(
    (sum, course) => sum + (course.userEnrollment?.completedSentences || 0),
    0,
  );
  const currentTotalCompleted = totalCompletedWords + totalCompletedSentences;

  // Update progress only if total has increased beyond the baseline
  if (currentTotalCompleted > userStore.dailyBaseline) {
    userStore.updateProgress(currentTotalCompleted);
  }
}

onMounted(async () => {
  const isNewDay = userStore.checkForNewDay();

  if (isNewDay) {
    await initializeDailyBaseline();
  } else {
    await updateDailyProgress();
  }

  window.addEventListener("update-progress", updateDailyProgress);
});

onUnmounted(() => {
  window.removeEventListener("update-progress", updateDailyProgress);
});

return (_ctx: any,_cache: any) => {
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h4", {
      class: _normalizeClass({ 'school-heading': isSchoolUser.value })
    }, _toDisplayString(_ctx.$t("dailyMilestoneBar.heading")), 3),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_v_progress_linear, {
          color: isSchoolUser.value ? '#FEC331' : 'yellow-accent-4',
          height: "14",
          "model-value": progressPercentage.value,
          striped: ""
        }, {
          default: _withCtx(() => [
            _createElementVNode("strong", null, _toDisplayString(_unref(userStore).currentProgress || 0), 1)
          ]),
          _: 1
        }, 8, ["color", "model-value"])
      ]),
      (_unref(userStore).currentProgress < 5)
        ? (_openBlock(), _createBlock(_component_v_icon, {
            key: 0,
            class: "start-icon"
          }, {
            default: _withCtx(() => [
              _createTextVNode("mdi-star")
            ]),
            _: 1
          }))
        : (_openBlock(), _createBlock(_component_v_icon, {
            key: 1,
            class: "end-icon"
          }, {
            default: _withCtx(() => [
              _createTextVNode("mdi-star")
            ]),
            _: 1
          }))
    ])
  ]))
}
}

})